import options from './chart-contact.component';

export default {
    selector: 'dtChartContact',
    options
};
